import {AgWedletBoxSelectionSingleElt} from "/@back@/edit/wed/features/boxSel.js";
import {AgWedletInsMgr, markInserts} from "/@back@/edit/wed/features/insMgr.js";
import {isWedDefaultDisplay, IWedChildrenElt, IWedDisplayElt, IWedletModel, IWedSelector, WED, WedletModelBase, WedModel} from "/@back@/edit/wed/wedCore.js";
import {WedMgr} from "/@back@/edit/wed/wedEditor.js";
import {BoxCreate, IBoxElement} from "/@back@/edit/wed/wedlets/box/boxTags.js";
import {
	EWedletEditMode,
	ICharsWedlet,
	IChildWedlet,
	ICustomClipboard,
	IEditableWedlet,
	IElementSkAnnot,
	IElementWedlet,
	IParentWedlet,
	IRootWedlet,
	IS_EltSkAnnot,
	IS_EltWedlet,
	isCustomClipboard,
	isDisplayedWedlet,
	ISkAnnotListener,
	IVirtualisableWedlet,
	IWedlet,
	IWedletEditModeHint,
	WEDLET
} from "/@back@/edit/wed/wedlets/wedlet.js";
import {AgWedletSingleElt, EWedletArch, isWedletSingleElt, IWedletSingleElt, OffView, WEDLET_SINGLEELT} from "/@back@/edit/wed/wedlets/wedletSingleElt.js";
import {DOM, ENodeType} from "/@lib@/commons/xml/dom.js";
import {IJmlNode, IJmlObj, IJmlSubSet, JML, JmlSubSetIterator} from "/@lib@/commons/xml/jml.js";
import {IXAddr, XA} from "/@lib@/commons/xml/xAddr.js";
import {FetchJml, IDocHolderSync} from "/@lib@/edit/docHolder.js";
import {CommentHouse} from "/@lib@/edit/ot/xmlTypedHouse.js";
import {OSkImportDatas} from "/@lib@/edit/schema/schemaMeta.js";
import {OffscreenEltLeafWedlet} from "/@back@/edit/wed/wedlets/offscreen/offscreen.js";
import {ISkAnnot, ISkAnnotFocuser, ISkStructDef, isSkAnnotDrawer, isSkAnnotFocuser, isSkStructDef, isSkTextAnnot} from "/@lib@/edit/schema/schemaAnnots.js";
import {EventMgr} from "/@lib@/commons/events.js";
import {LANG} from "/@lib@/commons/lang.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";


export const BOX_NS = "scenari.eu:wed:box";

/** wedlet="Box" */
export class BoxModel implements IWedletModel {

	nodeType: ENodeType;
	nodeName: string;
	modes: string[];

	nodeLabel?: string;

	/** Liste des childrenElt triés selon l'ordre de priorité de matching. */
	childrenElts: IWedChildrenElt[];

	/** Liste des childrenElt dans l'ordre naturel. */
	childrenEltsNaturalOrder: IWedChildrenElt[];

	/** IWedSelector si childrenElts vide. */
	defaultWedSelector?: IWedSelector;

	config: Element;

	wedletClass: Constructor<BoxWedlet>;

	/** Flag indiquant que ce wedlet est compatible dans l'environnement Box.*/
	get isBoxFamily(): boolean {return true}

	initModel(cnf: Element) {
		this.wedletClass = BoxWedlet;
		this.config = cnf;
		if (cnf.childElementCount !== 1) throw Error(`This wedlet must contain one and only one wedlet element: ${DOM.ser(cnf)}`);
		this.nodeLabel = cnf.getAttribute('label');
		this.childrenEltsNaturalOrder = WEDLET.extractChildrenNodes(cnf, (elt: Element, forChidrenElt?: IWedChildrenElt) => WEDLET.findWedSelector(elt, forChidrenElt) || WED_SELECTOR_BOX);
		if (this.childrenEltsNaturalOrder) {
			if (this.childrenEltsNaturalOrder.length > 1) {
				this.childrenElts = this.childrenEltsNaturalOrder.slice();
				this.childrenElts.sort(WED.SORT_ChildrenElts);
			} else {
				this.childrenElts = this.childrenEltsNaturalOrder;
			}
		} else {
			this.defaultWedSelector = WEDLET.findWedSelector(cnf.firstElementChild) || WED_SELECTOR_BOX;
		}
	}

	createWedlet(parent: IParentWedlet, displayContext?: IWedDisplayElt): IChildWedlet {
		return new this.wedletClass().init(parent, this, displayContext);
	}

	createRootWedlet(wContainer: Element, insertBefore: Node, wedMgr: WedMgr): IRootWedlet {
		const wedlet = new this.wedletClass().initAsRoot(wedMgr, this) as IRootWedlet & IWedletSingleElt;
		wedlet.insertElement(wContainer, insertBefore);
		return wedlet;
	}

	buildModelForFragment(insertCtx: BoxWedlet): IWedletModel {
		const model = new BoxModel();
		model.childrenEltsNaturalOrder = [];
		const doc = this.config.ownerDocument;
		//<wed:bind nodeType="all" wedlet="Box">
		// <box-static skin="box/root" skinOver="box/root/fragment" skins4frag="box/root ">
		// 	<box-host>
		// 		<wed:slot>...</wed:slot>
		// 	</box-host>
		// </box-static>
		//</wed:bind>
		const bind = doc.createElementNS(WED.WED_NS, "bind");
		bind.setAttribute("nodeType", "all"); //all = document ou documentFragment
		bind.setAttribute("wedlet", "Box");
		const styleCtn = insertCtx ? DOMSH.findHost(insertCtx.elementHost) : null;
		const box = bind.appendChild(doc.createElementNS(DOM.XHTML_NS, "box-static"));
		if (styleCtn) {
			let skins = styleCtn.getAttribute("skins4frag");
			if (skins) {
				box.setAttribute("skins4frag", skins); // en cas d'imbrication de fragments.
				const skinList = skins.split(' ');
				for (let i = 0; i < skinList.length; i++) {
					const sk = skinList[i];
					if (sk.charAt(0) === "#") {
						//id de tag style interne au shadowRoot.
						const styleTag = styleCtn.shadowRoot.getElementById(sk.substring(1));
						if (styleTag) box.appendChild(styleTag.cloneNode(true));
						skins = null;
						skinList.splice(i--, 1); //élimination du skinList pour l'attribut skinOver
					}
				}
				box.setAttribute("skinOver", skins || skinList.join(' '));
			}
		}
		const boxHost = box.appendChild(doc.createElementNS(DOM.XHTML_NS, "box-host"));
		const slot = boxHost.appendChild(doc.createElementNS(WED.WED_NS, "wed:slot"));
		if (this.childrenEltsNaturalOrder) for (const parentChElts of this.childrenEltsNaturalOrder) {
			const children = slot.appendChild(doc.createElementNS(WED.WED_NS, "children")) as IWedChildrenElt;
			children.wedMatcher = parentChElts.wedMatcher;
			children.wedMatchStrict = parentChElts.wedMatchStrict;
			children.wedModesNodes = parentChElts.wedModesNodes;
			children.wedModesAtts = parentChElts.wedModesAtts;
			children.wedVariants = parentChElts.wedVariants;
			children.wedParams = parentChElts.wedParams;
			children.wedSlotName = "";
			children.wedSelector = parentChElts.wedSelector;
			children.wedPreferedModels = parentChElts.wedPreferedModels;
			if (parentChElts.wedDisplays) {
				//pas de display mais on les ajoute alors aux wedPreferedModels si ils sont internalisés.
				children.wedPreferedModels = children.wedPreferedModels?.slice() || [];
				for (const disp of parentChElts.wedDisplays) {
					if (disp.wedletModel) children.wedPreferedModels.push(disp.wedletModel);
				}
			}
			model.childrenEltsNaturalOrder.push(children);
		}
		model.wedletClass = BoxWedlet;
		model.config = bind;
		if (model.childrenEltsNaturalOrder.length > 1) {
			model.childrenElts = model.childrenEltsNaturalOrder.slice();
			model.childrenElts.sort(WED.SORT_ChildrenElts);
		} else {
			model.childrenElts = model.childrenEltsNaturalOrder;
		}
		return model;
	}

	get attsOrder(): string[] | null {
		//On prend toutes les déclaration nommées d'attribut dans l'odre naturel
		if (this._attsOrder == undefined) {
			this._attsOrder = [];
			if (this.childrenEltsNaturalOrder) for (let wedCh of this.childrenEltsNaturalOrder) {
				let bind = wedCh.firstElementChild;
				while (bind) {
					const att = bind.getAttribute("attName");
					if (att) this._attsOrder.push(att);
					bind = bind.nextElementSibling;
				}
			}
		}
		return this._attsOrder;
	}

	protected _attsOrder?: string[] | null
}

WED.registerWedletModel("Box", BoxModel);

/**
 * Wedlet gérant un widegt en virtual (1er élément fils du wedlet)
 * et un widget en real (2ème élément fils du wedlet).
 * cf le widget <box-create/>, bouton de création de la structure virtuelle
 * à utiliser pour le contexte virtuel. Si ce bouton n'est pas l'élément racine,
 * utiliser un <box-static/> pour container racine.
 */
export class BoxVirtualSwitchModel extends BoxModel {

	virtualEltWedletConfig: Element;
	realEltWedletConfig: Element;

	/** Liste des childrenElt dans l'ordre naturel pour le bloc virtuel. */
	chEltsNatOrderVirtual: IWedChildrenElt[];

	initModel(cnf: Element) {
		this.wedletClass = BoxVirtualSwitchWedlet;
		this.config = cnf;
		if (cnf.childElementCount !== 2) throw Error(`This wedlet must contain two and only two children elements: ${DOM.ser(cnf)}`);
		this.nodeLabel = cnf.getAttribute("label");
		this.virtualEltWedletConfig = cnf.firstElementChild;
		this.realEltWedletConfig = cnf.lastElementChild;
		this.chEltsNatOrderVirtual = WEDLET.extractChildrenNodes(this.virtualEltWedletConfig, (elt: Element, forChidrenElt?: IWedChildrenElt) => WEDLET.findWedSelector(elt, forChidrenElt) || WED_SELECTOR_BOX);
		this.childrenEltsNaturalOrder = WEDLET.extractChildrenNodes(this.realEltWedletConfig, (elt: Element, forChidrenElt?: IWedChildrenElt) => WEDLET.findWedSelector(elt, forChidrenElt) || WED_SELECTOR_BOX);
		if (this.childrenEltsNaturalOrder) {
			this.childrenElts = this.childrenEltsNaturalOrder.slice();
			this.childrenElts.sort(WED.SORT_ChildrenElts);
		} else {
			this.defaultWedSelector = WEDLET.findWedSelector(this.realEltWedletConfig) || WED_SELECTOR_BOX;
		}
	}
}

WED.registerWedletModel("BoxVirtualSwitch", BoxVirtualSwitchModel);


/**
 * Wedlet pour les commentaires gérant le switch entre
 * commentaire text brut, commentaire structuré XML et commentaire avec les schéma Scenari.
 */
export class BoxCommentModel extends BoxModel {

	/** Wedlet def pour commentaire texte (défaut) */
	textCmtConfig: Element;

	/** Wedlet def pour commentaire d'exclusion Scenari */
	exclCmtConfig: Element;

	/** Wedlet def pour commentaire de discussion Scenari */
	scCmtConfig: Element;

	initModel(cnf: Element) {
		this.wedletClass = BoxCommentWedlet;
		this.config = cnf;
		const count = cnf.childElementCount;
		if (count < 2 || count > 3) throw Error(`This wedlet must contain 2 or 3 children elements: ${DOM.ser(cnf)}`);
		this.nodeLabel = "Commentaire";
		this.textCmtConfig = cnf.firstElementChild;
		if (cnf.lastElementChild.previousElementSibling !== cnf.firstElementChild) {
			this.exclCmtConfig = cnf.lastElementChild.previousElementSibling;
		}
		this.scCmtConfig = cnf.lastElementChild;
	}
}

WED.registerWedletModel("BoxScComment", BoxCommentModel);


export const WED_SELECTOR_BOX: IWedSelector = function (wedModel: IWedletModel, node: IJmlNode | string, ctx: WedMgr | IWedlet) {
	if ((wedModel as BoxModel).isBoxFamily) return WedModel.SELECTOR_PERFECT_MATCH;
	return WedModel.SELECTOR_REJECT;
};

/**
 *
 */
export class BoxWedlet implements IRootWedlet, IParentWedlet, IChildWedlet, ICharsWedlet, IVirtualisableWedlet, IWedletSingleElt, IEditableWedlet, ISkAnnotFocuser, ICustomClipboard {

	model: BoxModel;

	wedParent: IParentWedlet;

	xaPart: number | string | null;

	wedNodeName: string;

	/** null indique qu'il n'est plus connecté (a été supprimé). */
	element: IBoxElement & HTMLElement | null;

	get elementHost(): HTMLElement {return this.element ? this.element.delegatedHost || this.element : null}

	get wedMgr(): WedMgr {return this.wedParent.wedMgr}

	get wedAnchor(): IXAddr {return XA.append(this.wedParent.wedAnchor, this.xaPart != null ? this.xaPart : (this as IVirtualisableWedlet).getVirtualXaPart())}

	displayCtx: IWedDisplayElt;

	editMode: EWedletEditMode;

	customAdjust?: EventMgr<(w: BoxWedlet) => void>;

	init(host: IParentWedlet, model: BoxModel, displayContext?: IWedDisplayElt): this {
		this.wedParent = host;
		this.model = model;
		if (displayContext) this.displayCtx = displayContext;
		this.createElement(model.config.firstElementChild);
		return this;
	}

	initAsRoot(wedMgr: WedMgr, model: BoxModel): this {
		Object.defineProperty(this, 'wedMgr', {
			writable: false,
			value: wedMgr
		});
		this.model = model;
		this.createElement(model.config.firstElementChild);
		return this;
	}

	bindRoot(children: IJmlSubSet, node?: IJmlNode, xaRoot?: IXAddr): void | Promise<void> {
		Object.defineProperty(this, 'wedAnchor', {
			writable: false,
			value: XA.freeze(xaRoot || [])
		});
		this.xaPart = XA.last(this.wedAnchor) || 0;
		return this._bind(node, children);
	}

	bindWithNode(xaOffset: number, node: IJmlNode, children: IJmlSubSet): void | Promise<void> {
		this.xaPart = xaOffset;
		if (!this.model.nodeName && this.model.nodeType === ENodeType.element) {
			this.wedNodeName = JML.jmlNode2name(node);
		}
		return this._bind(node, children);
	}

	_bind(node: IJmlNode, children: IJmlSubSet) {
		this.refreshEditMode();
		this.element.refreshBindValue(node, children);
		let promises = WEDLET.appendAttWedlets(this, node, this.xInsertAttWedlet);
		if (children) promises = this.xAppendChildWedlets(children, promises);
		WEDLET_SINGLEELT.adjustVirtuals(this, this.model.childrenEltsNaturalOrder);
		if (promises != null) return Promise.all(promises) as any;
	}

	bindWithAttr(nameAttr: string, value: string): void | Promise<void> {
		this.xaPart = nameAttr;
		if (!this.model.nodeName) this.wedNodeName = nameAttr;
		/*if (this.element)*/
		this.refreshEditMode();
		this.element.refreshBindValue(value);
		//WEDLET_SINGLEELT.adjustVirtuals(this, this.model.childrenEltsNaturalOrder); pas de fils, pas de sens !
		this.doCustomAdjust();
	}

	protected createElement(root: Element) {
		this.element = document.importNode(root, false) as IElementWedlet;
		this.element.configWedletElt(root, this);
	}

	insertElement(parent: Element, insertBefore?: Node, slotName?: string, caller?: IWedChildrenElt) {
		if (slotName) this.element.setAttribute("slot", slotName);
		if (caller) this.element.fromChildrenElt = caller;
		parent.insertBefore(this.element, insertBefore);
	}


	insertChildNode(xaOffest: number, node: IJmlNode, children: IJmlSubSet): void | Promise<void> {
		let result;
		//on cherche le point d'insertion et on décale les autres binds
		for (let ch = this.elementHost.firstElementChild; ch; ch = ch.nextElementSibling) {
			if (IS_EltWedlet(ch)) {
				const xaPart = ch.wedlet.xaPart as number;
				if (xaPart > xaOffest) {
					ch.wedlet.xaPart = (xaPart as number) + 1;
				} else if (xaPart === xaOffest) {
					result = this.xInsertChildWedlet(xaOffest, node, children, ch) || null;
					ch.wedlet.xaPart = (xaPart as number) + 1;
				}
			}
		}
		//si pas trouvé on insère à la fin.
		if (result === undefined) result = this.xInsertChildWedlet(xaOffest, node, children, null);
		return result;
	}

	onDelete() {
		(this as IParentWedlet).visitWedletChildren(-1, Number.MAX_SAFE_INTEGER, (w: IWedlet) => {
			if ('onDelete' in w) w.onDelete();
		});
		this.element = null;
	}

	onChildNodesInserted() {
		WEDLET_SINGLEELT.adjustVirtuals(this, this.model.childrenEltsNaturalOrder);
	}


	replaceChildBind(xaOffest: number, node: IJmlNode, children: IJmlSubSet): void | Promise<void> {
		for (let ch = this.elementHost.firstElementChild; ch; ch = ch.nextElementSibling) {
			if (IS_EltWedlet(ch)) {
				if (ch.wedlet.xaPart === xaOffest) {
					let next = ch.nextElementSibling;
					while (IS_EltWedlet(next) && next.wedlet.isVirtual()) next = next.nextElementSibling;
					if ('onDelete' in ch.wedlet) ch.wedlet.onDelete();
					ch.remove(); //supprimé avant sinon le display virtuel correspondant n'est pas remplacé car offset incorrect.
					const result = this.xInsertChildWedlet(xaOffest, node, children, next);
					WEDLET_SINGLEELT.adjustVirtuals(this, this.model.childrenEltsNaturalOrder);
					return result;
				}
			}
		}
	}

	/** Redessine ce wedlet en réinterrogeant le jml intégral (sans threshold).  */
	redrawFull() {
		if (typeof this.xaPart === 'number') {
			//élement réel
			this.wedMgr.docHolderAsync.fetchContent([new FetchJml(this.wedAnchor)]).then(([f]) => {
				if (this.element.isConnected) this.wedParent.replaceChildBind(this.xaPart as number, f.result[0], f.result[1]);
			});
		}
	}

	deleteChildNodes(xaOffest: number, count: number) {
		WEDLET_SINGLEELT.deleteChildNodes(this, xaOffest, count);
		WEDLET_SINGLEELT.adjustVirtuals(this, this.model.childrenEltsNaturalOrder);
	}

	insertAttrNode(attrName: string, value: string): void | Promise<void> {
		const result = this.xInsertAttWedlet(attrName, value);
		WEDLET_SINGLEELT.adjustVirtuals(this, this.model.childrenEltsNaturalOrder);
		return result;
	}

	protected xInsertAttWedlet(attrName: string, value: string): void | Promise<void> {
		return WEDLET_SINGLEELT.insertAttrNode(this, attrName, value, this.model.childrenElts, this.model.defaultWedSelector);
	}

	deleteAttrNode(attName: string) {
		WEDLET_SINGLEELT.deleteAttrNode(this, attName);
		WEDLET_SINGLEELT.adjustVirtuals(this, this.model.childrenEltsNaturalOrder);
	}

	onChildEmptied(willBeEmptied: (xa: IXAddr) => boolean): IXAddr {
		//si ce wedlet n'est pas affiché systématiquement, il n'est pas supprimable par vidage de ses fils.
		if (!isDisplayedWedlet(this) || isWedDefaultDisplay(this.displayCtx)) {
			if (this.model.config.getAttribute("onChildrenEmptied") !== "delete") return null;
		} else if (this.model.config.getAttribute("onChildrenEmptied") === "preserve") return null;
		return WEDLET.onChildEmptied(this as IParentWedlet, willBeEmptied);
	}

	injectForeignChild(similarTo: IJmlObj | ISkStructDef | Node | Attr, elt: HTMLElement, before?: IWedlet, after?: IWedlet, options?: Dict<any>) {
		const model = this.model;
		//Recherche du slot
		let slot = null;
		if (model.childrenElts) {
			if (model.childrenElts.length === 1) {
				slot = model.childrenElts[0].wedSlotName;
			} else {
				let childrenElt: IWedChildrenElt;
				if (isSkStructDef(similarTo)) {
					childrenElt = model.childrenElts.find((c: IWedChildrenElt) => c.wedMatcher.matchStruct(similarTo));
				} else if (similarTo instanceof Attr) {
					childrenElt = model.childrenElts.find((c: IWedChildrenElt) => c.wedMatcher.matchAttr(similarTo.nodeName));
				} else if (similarTo instanceof Node) {
					childrenElt = model.childrenElts.find((c: IWedChildrenElt) => c.wedMatcher.matchNode(JML.dom2jmlNode(similarTo)));
				} else {
					// similarTo is IJmlObj
					childrenElt = model.childrenElts.find((c: IWedChildrenElt) => c.wedMatcher.matchNode(similarTo));
				}
				if (childrenElt) slot = childrenElt.wedSlotName;
			}
		}
		if (slot) elt.setAttribute("slot", slot);
		//Recherche du point d'insertion
		const parent = this.elementHost;
		let beforeNode: Node;
		if (isWedletSingleElt(before)) {
			beforeNode = this.findPreviousInsBefore(parent, before.element, similarTo);
		} else if (isWedletSingleElt(after)) {
			let stopPoint = after.element.nextElementSibling;
			let doc: IDocHolderSync;
			let xa: IXAddr;
			let eltName: string;
			while (stopPoint) {
				if (IS_EltWedlet(stopPoint)) {
					if (stopPoint.wedlet.isVirtual()) {
						if (!doc) {
							doc = this.wedMgr.docHolder;
							xa = this.wedAnchor;
							eltName = isSkStructDef(similarTo) ? similarTo.structName :
								similarTo instanceof Node ? similarTo.nodeName : JML.jmlNode2name(similarTo)
						}
						if (doc.checkSchemaOrder(xa, eltName, stopPoint.wedlet.model.nodeName)) break;
					} else if (LANG.in(stopPoint.wedlet.model.nodeType, ENodeType.element, ENodeType.attribute)) {
						//autre élément ou attribut non virtuel on arrête.
						break;
					}
				}
				stopPoint = stopPoint.nextElementSibling;
			}
			beforeNode = stopPoint || after.element.nextSibling;
		} else {
			beforeNode = this.findPreviousInsBefore(parent, null, similarTo);
		}
		parent.insertBefore(elt, beforeNode);
	}

	protected findPreviousInsBefore(parent: HTMLElement, from: HTMLElement | null, similarTo: IJmlObj | ISkStructDef | Node | Attr): Node {
		let stopPoint = from == null ? parent.lastElementChild : from.previousElementSibling;
		let doc: IDocHolderSync;
		let xa: IXAddr;
		let eltName: string;
		while (stopPoint) {
			if (IS_EltWedlet(stopPoint)) {
				if (stopPoint.wedlet.isVirtual()) {
					if (!doc) {
						doc = this.wedMgr.docHolder;
						xa = this.wedAnchor;
						eltName = isSkStructDef(similarTo) ? similarTo.structName :
							similarTo instanceof Node ? similarTo.nodeName : JML.jmlNode2name(similarTo)
					}
					if (doc.checkSchemaOrder(xa, stopPoint.wedlet.model.nodeName, eltName) === false) {
						stopPoint = stopPoint.previousElementSibling;
						continue;
					}
				}
			}
			break;
		}
		return stopPoint ? stopPoint.nextSibling : parent.firstChild;
	}

	getEditModeForDesc(target: IWedlet | null): IWedletEditModeHint | undefined {
		//On force le mode readStatic si on est collapsé et hidden si on est virtuel.
		if (this.element?.collapsed) return target?.isVirtual() ? WEDLET.HIDDEN_MUST : WEDLET.READSTATIC_MUST;
		return undefined;
	}

	refreshEditMode() {
		const old = this.editMode;
		this.editMode = WEDLET.resolveEditMode(this);
		if (this.element && old !== this.editMode && 'setEditMode' in this.element) this.element.setEditMode(this.editMode);
		else if (typeof this.element.reassessPerms === "function") this.element.reassessPerms();
	}

	switchToRecursiveVirtualButton(): void {
		this.xaPart = null;
		this.element = new BoxCreate();
		this.element.configWedletElt(BoxWedlet.getRecursiveVirtualButtonTpl(), this);
		if (this.model.nodeLabel) (this.element as HTMLElement).appendChild(document.createElement('span')).appendChild(document.createTextNode(this.model.nodeLabel));
	}

	protected static _RecursVirtBtnTpl: Element;

	protected static getRecursiveVirtualButtonTpl(): Element {
		if (!BoxWedlet._RecursVirtBtnTpl) {
			const elt = BoxWedlet._RecursVirtBtnTpl = new BoxCreate();
			elt.setAttribute("skinOver", "box-create/recursive");
		}
		return BoxWedlet._RecursVirtBtnTpl;
	}

	protected xInsertChildWedlet(index: number, node: IJmlNode | number, children: IJmlSubSet, insertBefore?: Element): void | Promise<void> {
		if (typeof node === 'number') {
			const elt = new OffView().initViewOff(this, index, node);
			// XXX cas multi-slots pour les children : risque de se tromper de childrenElt.
			// => Insérer des BoxOffView slaves dans les autres slots (qui ne sont pas un chilrenElt d'attributs) ?
			const childrenElt = WEDLET.findChildrenEltForNode(this.model.childrenElts, null, this, index); //on cherche le childrenElt par défaut.
			if (childrenElt && childrenElt.wedSlotName) elt.setAttribute("slot", childrenElt.wedSlotName);
			(elt as IElementWedlet).fromChildrenElt = childrenElt;
			//On replace l'espion off-view avant les virtual nodes.
			let previousNotVirtual = insertBefore ? insertBefore.previousElementSibling : this.elementHost.lastElementChild;
			while (previousNotVirtual && IS_EltWedlet(previousNotVirtual) && previousNotVirtual.wedlet.isVirtual()) {
				insertBefore = previousNotVirtual;
				previousNotVirtual = previousNotVirtual.previousElementSibling;
			}
			this.elementHost.insertBefore(elt, insertBefore);
		} else {
			return WEDLET_SINGLEELT.insertChildNode(this, index, node, children, this.model.childrenElts, this.model.defaultWedSelector, insertBefore);
		}
	}

	protected xAppendChildWedlets(children: IJmlSubSet, promises?: Promise<void>[]): Promise<void>[] {
		const it = new JmlSubSetIterator(children);
		while (it.next()) {
			const promise = this.xInsertChildWedlet(it.currentIdx, it.currentNode, it.currentChildren);
			if (promise) {
				if (!promises) promises = [promise];
				else promises.push(promise);
			}
		}
		return promises;
	}

	isVirtual() {return this.xaPart === null}

	bindAsVirtual() {
		this.xaPart = null;
		if (!this.model.nodeName && (this.model.nodeType === ENodeType.element || this.model.nodeType === ENodeType.attribute)) {
			//On est obligé de mettre un nom valide en cas de création forcé de l'arbo par la création d'un descendant virtuel.
			this.wedNodeName = (this.displayCtx ? this.displayCtx.wedNodeName : null) || "x";
		}
		/*if (this.element) { ...*/
		this.refreshEditMode();
		WEDLET_SINGLEELT.clearChildrenAsVirtual(this);
		this.element.refreshBindValue(null);
		WEDLET_SINGLEELT.adjustVirtuals(this, this.model.childrenEltsNaturalOrder);
	}

	deleteVirtualWedlet() {
		this.element.remove();
	}

	newJml(): IJmlNode {
		switch (this.model.nodeType) {
		case ENodeType.element:
			return {'': this.wedNodeName || this.model.nodeName};
		case ENodeType.text:
			return "";
		case ENodeType.comment:
			return {'': JML.COMMENT};
		}
		return null;
	}

	isEmpty(): boolean {
		if (this.isVirtual()) return true;
		//un contenu qui n'est pas issu d'un display systématique (non 'default') est considéré comme jamais vide.
		if ((!isDisplayedWedlet(this) || isWedDefaultDisplay(this.displayCtx)) && this.wedMgr.rootWedlet !== this) return false;
		switch (this.model.nodeType) {
		case ENodeType.element:
		case ENodeType.document:
		case ENodeType.documentFragment:
			let empty = true;
			(this as IParentWedlet).visitWedletChildren(-1, Infinity, (wedlet: IChildWedlet) => {
				if (!wedlet.isEmpty()) {
					empty = false;
					return 'stop';
				}
			}, WEDLET.VISITOPTIONS_mainBranch);
			return empty;
		case ENodeType.text:
		case ENodeType.attribute:
			return this.element.isEmpty();
		default: //ENodeType.document, ENodeType.comment
			return false;
		}
	}

	get isCollapsed() {return false}

	async onClipboard(act: "copy" | "cut" | "paste", ev?: Event, options?: Dict<any>): Promise<boolean> {
		if (isCustomClipboard(this.element)) return this.element.onClipboard(act, ev, options);
		return false;
	}

	doCustomAdjust() {
		if (this.element.onChildWedletsChange) this.element.onChildWedletsChange();
		if (this.customAdjust) this.customAdjust.emit(this);
	}

	addCustomAdjust(lstn: (w: BoxWedlet) => void, order?: number) {
		if (!this.customAdjust) this.customAdjust = new EventMgr();
		this.customAdjust.add(lstn, order);
	}

	focusSkAnnot(annot: ISkAnnot): boolean {
		if (typeof annot.offset === "number") {
			//insertion entre wedlets => wedletOwner est le père.
			const a = DOM.findFirstChild(this.elementHost, (n: Node): n is IElementSkAnnot => IS_EltSkAnnot(n) && n.skAnnot === annot);
			if (a) {
				a.focus();
				return true;
			}
		} else if (isSkTextAnnot(annot)) {
			//Annotation dans un text ou attr, on cherche un widget qui pourrait le gérer plus finement.
			if (isSkAnnotFocuser(this.element) && this.element.focusSkAnnot(annot)) return true;
			const sh = this.element.shadowRoot;
			if (sh) return DOM.findNext(sh, sh, (n): n is Node => isSkAnnotFocuser(n) ? n.focusSkAnnot(annot) : false) != null;
		}
		return false;
	}

}

AgWedletInsMgr(AgWedletBoxSelectionSingleElt(AgWedletSingleElt(BoxWedlet, {wedletArch: EWedletArch.dom, isParentWedlet: true, isCharsWedlet: true, isVirtualisableWedlet: true, proxySkAnnots: true})));


/**
 *
 */
export class BoxVirtualSwitchWedlet extends BoxWedlet {
	model: BoxVirtualSwitchModel;

	init(host: IParentWedlet, model: BoxVirtualSwitchModel, displayContext?: IWedDisplayElt): this {
		this.wedParent = host;
		this.model = model;
		if (displayContext) this.displayCtx = displayContext;
		return this;
	}

	protected eltParent: Element;
	protected eltBefore: Node;
	protected eltSlot: string;
	protected eltCaller: IWedChildrenElt;

	insertElement(parent: Element, insertBefore?: Node, slotName?: string, caller?: IWedChildrenElt) {
		this.eltParent = parent;
		this.eltBefore = insertBefore;
		this.eltSlot = slotName;
		this.eltCaller = caller;
	}

	protected resetElt(real: boolean) {
		let parent: Node;
		let insertBefore: Node;
		let slot: string;
		let caller: IWedChildrenElt;
		if (this.element) {
			parent = this.element.parentNode;
			insertBefore = this.element.nextSibling;
			slot = this.element.getAttribute("slot");
			caller = this.element.fromChildrenElt;
			this.element.remove();
		} else {
			parent = this.eltParent;
			insertBefore = this.eltBefore;
			slot = this.eltSlot;
			caller = this.eltCaller;
			this.eltParent = undefined;
			this.eltBefore = undefined;
			this.eltSlot = undefined;
			this.eltCaller = undefined;
		}
		this.createElement(real ? this.model.realEltWedletConfig : this.model.virtualEltWedletConfig);
		if (slot) this.element.setAttribute("slot", slot);
		if (caller) this.element.fromChildrenElt = caller;
		parent.insertBefore(this.element, insertBefore);
	}

	bindWithNode(xaOffset: number, node: IJmlNode, children: IJmlSubSet): void | Promise<void> {
		this.resetElt(true);
		super.bindWithNode(xaOffset, node, children);
	}


	bindWithAttr(nameAttr: string, value: string): void | Promise<void> {
		this.resetElt(true);
		super.bindWithAttr(nameAttr, value);
	}

	bindAsVirtual() {
		if (!this.model.nodeName && (this.model.nodeType === ENodeType.element || this.model.nodeType === ENodeType.attribute)) {
			//On est obligé de mettre un nom valide en cas de création forcée de l'arbo par la création d'un descendant virtuel.
			this.wedNodeName = (this.displayCtx ? this.displayCtx.wedNodeName : null) || "x";
		}
		this.resetElt(false);
		this.xaPart = null;
		this.refreshEditMode();
		//WEDLET_SINGLEELT.clearChildrenAsVirtual(this);
		this.element.refreshBindValue(null);
		WEDLET_SINGLEELT.adjustVirtuals(this, this.model.chEltsNatOrderVirtual);
	}

	get isCollapsed() {return this.isVirtual()}

	/**
	 * Surcharge de AgWedletInsMgr.
	 * @override IInsMgrWedlet.markInserts
	 */
	markInserts(datas: OSkImportDatas): "next" | "nextSibling" {
		if (this.isVirtual()) return "nextSibling";
		return markInserts.call(this, datas);
	}
}


export class BoxCommentWedlet extends BoxWedlet {

	model: BoxCommentModel;

	cmtHouse: Promise<CommentHouse>;

	/** Reprise du texte en création de thread (stocké en lastDatas). */
	initText?: string;

	protected createElement(root: Element) {
		//création d'un élément temporaire, transformé après analyse du comment
		this.element = document.createElement("template") as any as Readonly<IElementWedlet>;
		this.element.configWedletElt = () => {};
		(this.element as any).wedlet = this;
	}

	bindWithNode(xaOffset: number, node: IJmlNode, children: IJmlSubSet) {
		this.xaPart = xaOffset;
		this.wedMgr.doAfterBatch(async () => {
			//Après le batch pour que this.wedAnchor soit synchro avec le docHolder
			const cmtHolder = this.wedMgr.docHolderAsync.getCmtHouse(this.wedAnchor);
			if (cmtHolder) {
				this.cmtHouse = cmtHolder.futureHouse;
				if (cmtHolder.type === "scCmt" && this.model.scCmtConfig) {
					if (!window.customElements.get("box-sccomment")) await import("/@back@/edit/wed/wedlets/box/boxScComment.js");
					this.initComment(this.model.scCmtConfig, node);
					return;
				} else if (cmtHolder.type === "scExcl" && this.model.exclCmtConfig) {
					if (!window.customElements.get("box-scexclude")) await import("/@back@/edit/wed/wedlets/box/boxScExclude.js");
					this.initComment(this.model.exclCmtConfig, node);
					return;
				}
			}
			this.initComment(this.model.textCmtConfig, node);
		});
	}

	bindAsVirtual() {
		this.xaPart = null;
		return import("/@back@/edit/wed/wedlets/box/boxScComment.js").then(() => {
			this.initComment(this.model.scCmtConfig, null);
		});
	}

	initComment(tpl: Element, node: IJmlNode) {
		const oldElt = this.element;
		super.createElement(tpl);
		this.insertElement(oldElt.parentElement, oldElt, oldElt.getAttribute("slot"), oldElt.fromChildrenElt);
		oldElt.remove();
		this.refreshEditMode();
		this.element.refreshBindValue(node);
		this.doCustomAdjust();
		if (this.pendingAnnots && isSkAnnotDrawer(this.element)) {
			for (const an of this.pendingAnnots) this.element.drawAnnot(an);
			this.pendingAnnots = null;
		}
	}

	pendingAnnots: ISkAnnot[];

	onAddedSkAnnot(annot: ISkAnnot): void {
		if (this.element.localName === "template") {
			//comment en construction async
			if (!this.pendingAnnots) this.pendingAnnots = [annot];
			else this.pendingAnnots.push(annot);
		} else {
			if (isSkAnnotDrawer(this.element)) this.element.drawAnnot(annot);
		}
	}

	onRemovedSkAnnot(annot: ISkAnnot): void {
		if (this.element.localName === "template") {
			//comment en construction async
			if (this.pendingAnnots) {
				const i = this.pendingAnnots.indexOf(annot);
				if (i >= 0) this.pendingAnnots.splice(i, 1);
			}
		} else {
			if (isSkAnnotDrawer(this.element)) this.element.eraseAnnot(annot);
		}
	}

	isEmpty(): boolean {return false}

	bindRoot() {throw Error("BoxCommentWedlet not implemented in root position")}

	bindWithAttr() {throw Error("BoxCommentWedlet not usable with attr binding")}
}

export class BoxHiddenModel extends WedletModelBase {
	nodeLabel?: string;

	get isBoxFamily(): boolean {return true}

	initModel(cnf: Element): void {
		this.config = cnf;
		this.nodeLabel = cnf.getAttribute('label');
	}

	createWedlet(parent: IParentWedlet, displayContext?: IWedDisplayElt): IChildWedlet | null {
		return new BoxHiddenWedlet(this, parent, displayContext);
	}
}

WED.registerWedletModel("BoxHidden", BoxHiddenModel);

export class BoxHiddenWedlet extends OffscreenEltLeafWedlet implements IWedletSingleElt, ICharsWedlet, IVirtualisableWedlet, ISkAnnotListener {
	model: BoxFreeDomModel;

	element: IElementWedlet;

	displayCtx: IWedDisplayElt;

	get elementHost(): HTMLElement {return this.element}

	isVirtual(): this is IVirtualisableWedlet {return this.xaPart == null}

	constructor(model: IWedletModel, wedParent: IParentWedlet, displayContext?: IWedDisplayElt) {
		super(model, wedParent);
		if (displayContext) this.displayCtx = displayContext;
	}

	bindWithNode(xaOffset: number, node: IJmlNode, children: IJmlSubSet): void | Promise<void> {
		this.xaPart = xaOffset;
	}

	bindAsVirtual(): void {
		this.xaPart = null;
	}

	bindWithAttr(nameAttr: string, value: string): void | Promise<void> {
		this.xaPart = nameAttr;
	}

	insertElement(parent: Element, insertBefore?: Node, slotName?: string, caller?: IWedChildrenElt): void {
		const elt = document.createElement("box-hidden") as IElementWedlet;
		elt.hidden = true;
		elt.style.display = "none";
		elt.configWedletElt = () => {};
		(elt as any).wedlet = this;
		elt.fromChildrenElt = caller;
		this.element = elt;
		if (slotName) elt.setAttribute("slot", slotName);
		parent.insertBefore(elt, insertBefore);
	}

	onAddedSkAnnot(annot: ISkAnnot) {};

	onRemovedSkAnnot(annot: ISkAnnot): void {};

	onDelete() {
		this.element = null;
	}

	deleteVirtualWedlet(): void {
		if (this.element) this.element.remove();
	}

	isEmpty(): boolean {return this.xaPart != null}

	newJml(): IJmlObj | string {throw Error()}
}

AgWedletSingleElt(BoxHiddenWedlet, {wedletArch: EWedletArch.dom, isVirtualisableWedlet: true});

/**
 * Wedlet dont le contenu est construit et mis à jour par une lib JS implémentant l'interface IBoxFreeDomDrawer.
 */
export class BoxFreeDomModel extends WedletModelBase {
	nodeLabel?: string;

	/** Fonction de redessinement du wedlet suite à création/modification/suppression des metas. */
	drawerLib: string;
	drawerMeth: string;

	get isBoxFamily(): boolean {return true}

	initModel(cnf: Element): void {
		if (this.nodeType !== ENodeType.element) throw Error("BoxFreeDom wedlet can only be bound with element.");
		this.config = cnf;
		this.nodeLabel = cnf.getAttribute('label');
		this.drawerLib = cnf.getAttribute('lib');
		this.drawerMeth = cnf.getAttribute('method');
	}

	createWedlet(parent: IParentWedlet, displayContext?: IWedDisplayElt): IChildWedlet | null {
		return new BoxFreeDomWedlet(this, parent);
	}

	getDrawer(wedMgr: WedMgr): IBoxFreeDomDrawer {
		return wedMgr.wedModel.jsLibs[this.drawerLib][this.drawerMeth];
	}
}

WED.registerWedletModel("BoxFreeDom", BoxFreeDomModel);

/**
 * Interface à implémenter par la lib.
 */
export interface IBoxFreeDomDrawer {

	/**
	 * Initialisation du noeud et insertion dans son contexte.
	 * wedlet.element DOIT être renseigné.
	 */
	createElement(wedlet: BoxFreeDomWedlet, parent: Element, insertBefore?: Node, slotName?: string, caller?: IWedChildrenElt): HTMLElement

	/** Appelé à chaque changement du contenu. */
	refreshContent(wedlet: BoxFreeDomWedlet): void

	/** */
	onDelete?(wedlet: BoxFreeDomWedlet): void
}

export class BoxFreeDomWedlet extends OffscreenEltLeafWedlet implements IWedletSingleElt {
	model: BoxFreeDomModel;

	element: IElementWedlet;

	get elementHost(): HTMLElement {return this.element}

	insertElement(parent: Element, insertBefore?: Node, slotName?: string, caller?: IWedChildrenElt): void {
		const elt = this.model.getDrawer(this.wedMgr).createElement(this, parent, insertBefore, slotName, caller) as any;
		if (!IS_EltWedlet(elt)) (elt as IElementWedlet).configWedletElt = () => {};
		elt.wedlet = this;
		this.element = elt;
		if (slotName) elt.setAttribute("slot", slotName);
		parent.insertBefore(elt, insertBefore);
	}

	protected setContent(content: Element) {
		this.content = content;
		const drawer = this.model.getDrawer(this.wedMgr);
		if (content) drawer.refreshContent(this);
		else if ('onDelete' in drawer) drawer.onDelete(this);
	}
}
